const checkRoutePermissions = (authData: any, route: any) => {

  //   DDTD ADMIN
  if (authData.isSuperUser) {
    return true; // DDTD ADMINS can see everything except Account (They See admin Panel instead)
  }

  //   DDTD ADMIN
  if (authData.isDDTDAdmin) {
    if (['custom-fields'].includes(route.state)) return false; // Routes That are Hidden
    if ([''].includes(route.state)) { // Routes That are Greyed Out as inaccessible for current Tier
      return 'premium';
    }
    return true;
  }
  //   return true; // DDTD ADMINS can see everything except Account (They See admin Panel instead)
  // }

  //   DDTD USER
  if (authData.isDDTDUser) {
    if (['batches', 'custom-fields', 'swagger-api-keys'].includes(route.state)) return false; // Routes That are Hidden
    if ([''].includes(route.state)) { // Routes That are Greyed Out as inaccessible for current Tier
      return 'premium';
    }
    return true;
  }

  //   Organistation Admin
  if (authData.isOrganisationAdmin) {
    if (authData.user.organisation_api_access_enabled) {
      if (['organisations', 'batches'].includes(route.state)) return false; // Routes That are Hidden
    } else {
      if (['organisations', 'batches', 'swagger-api-keys'].includes(route.state)) return false; // Routes That are Hidden
    }
    if ([''].includes(route.state)) { // Routes That are Greyed Out as inaccessible for current Tier
      return 'premium';
    }
    return true;
  }

  //   Organistation User
  if (authData.isOrganisationUser) {
    if (['organisations', 'batches', 'custom-fields', 'swagger-api-keys', 'results-bulk-review'].includes(route.state)) return false; // Routes That are Hidden
    if ([''].includes(route.state)) { // Routes That are Greyed Out as inaccessible for current Tier
      return 'premium';
    }
    return true;
  }

  //   Organistation User
  if (authData.isApiUser) {
    if (['organisations', 'batches', 'custom-fields', 'results', 'results-bulk-review'].includes(route.state)) return false; // Routes That are Hidden
    if ([''].includes(route.state)) { // Routes That are Greyed Out as inaccessible for current Tier
      return 'premium';
    }
    return true;
  }

  return false;
};


export default checkRoutePermissions;